/**
 * RestoID — MFA onboarding ("turn on 2-step verification").
 * ---------------------------------------------------------------------------
 * RestoID frame (hero + concise copy) around the PRISTINE upstream enable/skip
 * logic (`useEnableMfa` / `useSkipMfa`). Replaces Logto's verbose default copy.
 * Swapped in for `./pages/MfaOnboarding` via `src/App.tsx`.
 */
import { useTranslation } from 'react-i18next';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';
import useEnableMfa from '@/hooks/use-enable-mfa';
import useSkipMfa from '@/hooks/use-skip-mfa';

import { Button, GhostAction, HeroTile, ScreenHead, Stack } from '../components/restoid';
import { useCopy } from '../copy';

const MfaOnboarding = () => {
  const { t } = useTranslation();
  const c = useCopy();
  const skipMfa = useSkipMfa();
  const enableMfa = useEnableMfa();

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'mfa.onboarding' }}>
      <Stack gap={22}>
        <ScreenHead title={c('mfaOnboardTitle')} sub={c('mfaOnboardDesc')} />
        <HeroTile icon="lock" />
        <Button title={c('mfaOnboardCta')} onClick={enableMfa} />
        <GhostAction onClick={() => skipMfa()}>{t('action.nav_skip')}</GhostAction>
      </Stack>
    </FirstScreenLayout>
  );
};

export default MfaOnboarding;
